import $ from 'jquery';
import { loadPosts } from '../utils/fetch-posts';

$(function() {

    // On location change, load 9 opportunities with that tag and render
    $('.js-location-select-btn').on('click', function() {

        const location = $('.js-location-select').val();
        const page = 1;

        // Load
        loadPosts({
            location, 
            page,
            replace: true,
            postType: 'opportunity'
        });

    });

    // On load more click, load next page or opportunities (applying location if applicable)
    $('.js-load-more-opportunities').on('click', function() {
        
        // Get page
        const page = $('.js-posts-grid').attr('data-page');
        const location = $('.js-location-select').val();

        // Load
        loadPosts({
            location,
            page,
            postType: 'opportunity',
        });
    
    });

    // On posts load more click
    $('.js-posts-load-more').on('click', function() {
        const location = $('.js-location-select').val() ?? null;
        const postType = $('.js-posts-load-more').attr('data-post-type') ?? 'post';
        loadPosts({
            location,
            page: $('.js-posts-grid').attr('data-page'),
            postType,
        });
    });

    // on clear filter click, load first 0 opportunities
    $('.js-clear-filter').on('click', function() {
        loadPosts({
            location: null, 
            page: 1,
            postType: 'opportunity',
        });
    });

});